import { has, have } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if ([undefined, "draft", "reEdit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCustoms" })) {
                if (["waitReceiveCustoms", "waitDocCustoms"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCenter" })) {
                if (["waitApproveCenter"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refUserTemp.refPersonType"].includes(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.registerDate",
                    "refUserTemp.refDepartmentRegister",
                    "refUserTemp.refDepartmentRegister.nameEn",
                    "refUserTemp.addresses.0.refAddressType",
                    "refUserTemp.addresses.1.refAddressType"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forOfficeRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (have({ menuContext, keys: ["forCustoms", "forCenter"] })) {
                    if (["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.refCompanyType",
                    "refUserTemp.companyNameTh",
                    "refUserTemp.companyNameEn",
                    // "refUserTemp.addresses.0.tel",
                    // "refUserTemp.addresses.0.fax",
                    // "refUserTemp.addresses.1.tel",
                    // "refUserTemp.addresses.1.fax"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refUserTemp.refPersonType?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.refIssuedBy",
                    "refUserTemp.outDate",
                    "refUserTemp.expireDate",
                    "refUserTemp.birthDate",
                    "refUserTemp.refNationality",
                    "refUserTemp.refRace",
                    "refUserTemp.refReligion",
                    "refUserTemp.refGender",
                    "refUserTemp.refTitle",
                    "refUserTemp.firstNameTh",
                    "refUserTemp.firstNameEn",
                    "refUserTemp.middleNameTh",
                    "refUserTemp.middleNameEn",
                    "refUserTemp.lastNameTh",
                    "refUserTemp.lastNameEn",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refUserTemp.refPersonType?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.mobile"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.refDocumentTypePerson"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refUserTemp.refPersonType?.key);
            },
            inputPropField: () => {
                let enabled = false;
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.idCard"].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { menuContext } = props;
                let enabled = false;
                let suffix = undefined;
                if (has({ menuContext, key: "forRequest" })) {
                    suffix = null;
                }
                if (has({ menuContext, key: "forCustoms" })) {
                    suffix = null;
                }
                return { disabled: !enabled, suffix };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.addresses.0.noTh",
                    "refUserTemp.addresses.0.noEn",
                    "refUserTemp.addresses.0.roomTh",
                    "refUserTemp.addresses.0.roomEn",
                    "refUserTemp.addresses.0.buildingTh",
                    "refUserTemp.addresses.0.buildingEn",
                    "refUserTemp.addresses.0.floorTh",
                    "refUserTemp.addresses.0.floorEn",
                    "refUserTemp.addresses.0.villageTh",
                    "refUserTemp.addresses.0.villageEn",
                    "refUserTemp.addresses.0.mooTh",
                    "refUserTemp.addresses.0.mooEn",
                    "refUserTemp.addresses.0.soiTh",
                    "refUserTemp.addresses.0.soiEn",
                    "refUserTemp.addresses.0.roadTh",
                    "refUserTemp.addresses.0.roadEn",
                    "refUserTemp.addresses.0.refProvince",
                    "refUserTemp.addresses.0.refAmphur",
                    "refUserTemp.addresses.0.refTambon",
                    "refUserTemp.addresses.0.postCode",
                    "refUserTemp.addresses.0.tel",
                    "refUserTemp.addresses.0.fax",
                    "refUserTemp.addresses.0.latitude",
                    "refUserTemp.addresses.0.longitude",
                    "refUserTemp.addresses.1.noTh",
                    "refUserTemp.addresses.1.noEn",
                    "refUserTemp.addresses.1.roomTh",
                    "refUserTemp.addresses.1.roomEn",
                    "refUserTemp.addresses.1.buildingTh",
                    "refUserTemp.addresses.1.buildingEn",
                    "refUserTemp.addresses.1.floorTh",
                    "refUserTemp.addresses.1.floorEn",
                    "refUserTemp.addresses.1.villageTh",
                    "refUserTemp.addresses.1.villageEn",
                    "refUserTemp.addresses.1.mooTh",
                    "refUserTemp.addresses.1.mooEn",
                    "refUserTemp.addresses.1.soiTh",
                    "refUserTemp.addresses.1.soiEn",
                    "refUserTemp.addresses.1.roadTh",
                    "refUserTemp.addresses.1.roadEn",
                    "refUserTemp.addresses.1.refProvince",
                    "refUserTemp.addresses.1.refAmphur",
                    "refUserTemp.addresses.1.refTambon",
                    "refUserTemp.addresses.1.postCode",
                    "refUserTemp.addresses.1.tel",
                    "refUserTemp.addresses.1.fax",
                    "refUserTemp.addresses.1.latitude",
                    "refUserTemp.addresses.1.longitude",
                    "refUserTemp.userOperatorTypes",
                    "refUserTemp.userObjectives"
                ].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.buttonCheckIdCard"].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (has({ menuContext, key: "forCenter" })) {
                    if (["waitApproveCenter"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                return result;
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.buttonCopyAddress"].includes(field?.key);
            },
            visibleField: ({ props, initialModel }) => {
                let result = false;
                const { menuContext } = props;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        result = true || result;
                    }
                }
                return result;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                let canCreate = false;
                let canDelete = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                        canCreate = !viewOnly || canCreate;
                        canDelete = !viewOnly || canDelete;
                    }
                }
                return { viewOnly: !enabled, canCreate, canDelete };
            }
        }
    ];
};
